import { Middleware } from "redux";
import { getType } from "typesafe-actions";
import { triggerEvent } from "../..";
import { completeLevel, startLevel } from "../game/actions";
import { loadScene } from "../routing/actions";

const triggableActionTypes = [
    getType(loadScene.success),
    getType(startLevel),
    getType(completeLevel)
];

function isTriggable(action: any) {
    return triggableActionTypes.includes(action.type);
}

export const gameEventsMiddleware: Middleware = store => next => {
    return action => {
        if (isTriggable(action)) {
            triggerEvent(action.type, action.payload);
        }

        return next(action);
    };
}